import { createContext } from "react"

export const initialState = {
    filters: null,
}

const initialDispatch = {}

export const HorizontalSigningStateContext = createContext(initialState)
export const HorizontalSigningDispatchContext = createContext(initialDispatch)
